if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoplayDelay = 4000;
      this.autoplay = null;

      if (!this.slider || this.length <= 1) return;

      this.setupSlides();
      this.updateSlides();
      this.startAutoplay();

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('next');
          this.startAutoplay();
        });
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('prev');
          this.startAutoplay();
        });
      }

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    setupSlides() {
      this.slider.style.position = 'relative';

      this.content.forEach((item, index) => {
        item.classList.toggle('is-active', index === 0);

        if (index !== 0) {
          item.style.position = 'absolute';
          item.style.top = '0';
          item.style.left = '0';
          item.style.width = '100%';
          item.style.opacity = '0';
          item.style.visibility = 'hidden';
          item.style.pointerEvents = 'none';
        } else {
          item.style.position = 'relative';
          item.style.opacity = '1';
          item.style.visibility = 'visible';
          item.style.pointerEvents = 'auto';
        }
      });
    }

    updateSlides() {
      this.content.forEach((item, index) => {
        const active = index === this.index;

        item.classList.toggle('is-active', active);
        item.style.position = active ? 'relative' : 'absolute';
        item.style.top = active ? '' : '0';
        item.style.left = active ? '' : '0';
        item.style.width = active ? '' : '100%';
        item.style.opacity = active ? '1' : '0';
        item.style.visibility = active ? 'visible' : 'hidden';
        item.style.pointerEvents = active ? 'auto' : 'none';
      });
    }

    changeSlide(direction) {
      if (direction === 'next') {
        this.index = (this.index + 1) % this.length;
      } else if (direction === 'prev') {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.updateSlides();
    }

    startAutoplay() {
      if (this.autoplay) return;

      this.autoplay = setInterval(() => {
        this.changeSlide('next');
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      clearInterval(this.autoplay);
      this.autoplay = null;
    }
  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}